import {
  PartnerRestResource,
  CreatePartnerRequest,
  CreatePartnerResponse,
  UpdatePartnerRequest,
  UpdatePartnerResponse,
  GetPartnerRequest,
  GetPartnerResponse,
} from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";

export const useCreatePartner = () =>
  useRestResourceHook<CreatePartnerRequest, CreatePartnerResponse>((request) =>
    PartnerRestResource.createPartner(request),
  );

export const useUpdatePartner = () =>
  useRestResourceHook<UpdatePartnerRequest, UpdatePartnerResponse>((request) =>
    PartnerRestResource.updatePartner(request),
  );

export const useGetPartner = () =>
  useRestResourceHook<GetPartnerRequest, GetPartnerResponse>((request) =>
    PartnerRestResource.getPartner(request),
  );
